export default "__VITE_ASSET__C2TZvV36__"